import { prop } from 'ramda';
import { dispatcher } from 'dispatcher';
import React, { memo, useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { useUserSelector } from 'js/store/hooks';
import { useComponentConfig } from 'js/hooks/component';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';

import * as Types from './types';
import { IGamesGridConfig } from '../../../../types';
import { useDynamicReducerSelector } from '../../../../store';

import style from './GameDemoButton.scss';

export const GameDemoButtonBare: React.FC<Types.IGameDemoButtonProps> = ({ game, className = '' }) => {
    const { gameCode: code } = game;
    const translate = useTranslations();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const feedName = useDynamicReducerSelector(prop('feedName'));
    const { queryStringParameters: queryString } = useComponentConfig<IGamesGridConfig>();

    const isGameDemoModeEnabled =
        isLoggedIn && game.demoModeSupport !== 'unavailable' && game.demoModeSupport !== 'guest' ||
        !isLoggedIn && game.demoModeSupport !== 'unavailable';

    const onClick = useCallback(() => {
        dispatcher.dispatch('game:launch', { code, container: 'games-grid', gameFeed: feedName, mode: 0, queryString });
    }, [code, feedName, queryString]);

    if (!isGameDemoModeEnabled) {
        return null;
    }

    return (
        <AccessibilityElement
            role="button"
            onClick={onClick}
            title={game?.name}
            className={`${style.button} ${className} cms-games-grid-game-demo-button`}
            aria-label={translate('playtech.mobile.system.games-grid.game.demoButton')}
        >
            {translate('playtech.mobile.system.games-grid.game.demoButton')}
        </AccessibilityElement>
    );
};

export const GameDemoButton = memo(GameDemoButtonBare);
